import PropTypes from 'prop-types';

export const roleCardConfigProp = PropTypes.arrayOf(
  PropTypes.shape({
    name: PropTypes.string.isRequired,
    ordinal: PropTypes.number.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }),
);
